import { defineMessages } from 'react-intl';

/**
 * The cross-organization conflict, reported under both the site and the
 * Bitbucket picker. Declared once and shared rather than per selector: the two
 * fields show the same sentence, so a single id keeps one string to translate.
 */
export const orgMismatchMessages = defineMessages({
  orgMismatch: {
    id: 'oauth.mcp.orgMismatch',
    defaultMessage:
      'Select a site and workspace from the same organization to continue.',
    description:
      'Message below the site and Bitbucket workspace pickers when the two selections belong to different Atlassian organizations, which cannot be granted in one consent',
  },
});
